import { GitHubLinkHovercardProvider } from "./github-link-hovercard.ts";

if (!customElements.get("altto-github-link-hovercard-provider")) {
  customElements.define("altto-github-link-hovercard-provider", GitHubLinkHovercardProvider);
}
